import { id } from "date-fns/locale"

  export const reportSubmenu = [
    {
      value: null,
      type: 'REPORT',
      name: 'Hành trình xe chạy',
      url: '/app/baocao-bgt/tt073/hanh-trinh-chay-xe'
    },
    {
      value: null,
      type: 'REPORT',
      name: 'Tốc độ vận hành của xe',
      url: '/app/baocao-bgt/tt073/toc-do-cua-xe'
    },
    {
      value: null,
      type: 'REPORT',
      name: 'Quá tốc độ cách nhau',
      url: '/app/baocao-bgt/tt073/qua-toc-do-gioi-han'
    },
    {
      value: null,
      type: 'REPORT',
      name: 'Thời gian lái xe liên tục',
      url: '/app/baocao-bgt/tt073/thoi-gian-lai-xe-lien-tuc'
    },
    {
      value: null,
      type: 'REPORT',
      name: 'Báo cáo tổng hợp theo xe',
      url: '/app/baocao-bgt/tt073/bao-cao-tong-hop-theo-xe'
    },
    // {
    //   value: null,
    //   type: 'REPORT',
    //   name: 'Báo cáo tổng hợp theo lái xe',
    //   url: '/app/baocao-bgt/tt073/bao-cao-tong-hop-theo-lai-xe'
    // },
    {
      value: null,
      type: 'REPORT',
      name: 'Báo cáo dừng đỗ',
      url: '/app/baocao-bgt/tt073/thoi-gian-lai-xe-lien-tuc'
    },
    {
      value: null,
      type: 'REPORT',
      name: 'Báo cáo hình ảnh',
      url: '/app/baocao-bgt/tt073/bao-cao-hinh-anh'
    },
  ]

  export const roadSubmenu = [
    // {
    //   value: 0.5,
    //   type:'ROAD',
    //   name: '30 phút gần đây',
    //   url: '/app/map'
    // },
    {
      value: 1,
      type:'ROAD',
      name: '1 giờ gần đây',
      url: '/app/map'
    },
    {
      value: 2,
      type:'ROAD',
      name: '2 giờ gần đây',
      url: '/app/map'
    },
    {
      value: 4,
      type:'ROAD',
      name: '4 giờ gần đây',
      url: '/app/map'
    },
    {
      value: 8,
      type:'ROAD',
      name: '8 giờ gần đây',
      url: '/app/map'
    },
    {
      value: 0,
      type:'ROAD',
      name: 'Tùy chọn',
      url: '/app/map'
    },
  ]

  export const titleTableHeader = [
    {
      id:1,
      name:'Tên/Biển số',
    },
    {
      id:2,
      name:'Vận tốc (Km/h)',
    },
    {
      id:3,
      name:'Thời gian',
    },
  ]

  export const titleTableRoadMap = [
    {
      id:1,
      name:'Thời gian',
    },
    {
      id:2,
      name:'Vận tốc cơ',
    },
    {
      id:3,
      name:'Vận tốc GPS',
    },
    {
      id:4,
      name:'Động cơ',
    },
  ]
